<div *ngIf="phase" class="container" [ngClass]="{'ionic' : useIonic}">
    <div class="jump-buttons margin">
        <button *ngIf="!useIonic" class="general-link-boto jump" (click)="goToActiveRoute()"><i class="fa fa-share"
                aria-hidden="true"></i>{{'SHARED.ACTIVE.ROUTE.PHASE.COMPONENT.OPTION.AR.PROMPT' |
            translate}}</button>
        <button *ngIf="!useIonic" class="general-link-boto jump" (click)="goToActiveSlots()"><i class="fa fa-share"
                aria-hidden="true"></i>{{'SHARED.ACTIVE.ROUTE.PHASE.COMPONENT.OPTION.AS.PROMPT' |
            translate}}</button>
    </div>

    <div class="margin">
        <options [optionstrip]="options" (clickOption)="onClickOption($event)"></options>
    </div>

    <!-- INFORMACIÓ (NO EXWORK) -->
    <div class="tab" *ngIf="selectedOptionId == 'info' && !isExwork">
        <shared-active-slots-item-phase [phase]="phase" class="margin no-help"
            [hideLink]="true"></shared-active-slots-item-phase>

        <div class="map-container">
            <shared-map class="mapa" [forcedZoom]="zoom" [latitude]="phase.latitude" [longitude]="phase.longitude"
                [marcadors]="marcadors">
            </shared-map>
        </div>

    </div>

    <!-- INFORMACIÓ (EXWORK) -->
    <div class="margin tab" *ngIf="selectedOptionId == 'info' && isExwork">
        <shared-exwork-phasecard-component class="margin no-help" [phase]="phase"
            [ngClass]="{'requiresSlot':phase.requiresSlot,'noRequiresSlot':!phase.requiresSlot}">
        </shared-exwork-phasecard-component>

        <div class="map-container">
            <shared-map class="mapa" [forcedZoom]="zoom" [latitude]="phase.latitude" [longitude]="phase.longitude"
                [marcadors]="marcadors">
            </shared-map>
        </div>

    </div>

    <!-- SLOT I MOLL (NO EXWORK) -->
    <div class="margin tab" *ngIf="selectedOptionId == 'slot' && !isExwork">
        <shared-dock-picker [modeByPhase]="true" [hideTitle]="false" class="block-option hide-bloqueig hide-lastmoments"
            *ngIf="phase" [phaseId]="phase.phaseId">
        </shared-dock-picker>
        <shared-slot-picker class="block-option hide-lastmoments" *ngIf="phase" [phase]="phase"></shared-slot-picker>
    </div>

    <!-- SLOT I MOLL (EXWORK) -->
    <div class="margin tab" *ngIf="selectedOptionId == 'slot' && isExwork">
        <shared-exwork-phasecard-component class="margin no-help noRequiresSlot" [phase]="phase"></shared-exwork-phasecard-component>
        <shared-exwork-slotpicker-component *ngIf="phase" [phase]="phase"></shared-exwork-slotpicker-component>
    </div>

    <!-- HISTORIAL -->
    <div class="margin tab" *ngIf="selectedOptionId == 'historial'">
        <shared-route-item-log-maintenance [routeId]="routeId"></shared-route-item-log-maintenance>
    </div>

    <!-- NOTES (NO EXWORK) -->
    <div class="margin tab" *ngIf="selectedOptionId == 'notes' && !isExwork">
        <shared-chat class="suau no-participants chats-body-zonachat chat-without-header" [notes]="true"
            [forcedOwnerParticipant]="routeChatForcedOwnerParticipant">
        </shared-chat>
    </div>


</div>